import React from 'react';
import styled from 'styled-components';
import { intervalToDuration } from 'date-fns';
import { Text } from '@companycam/slab-web';

const ContainerDiv = styled.div`
  margin-top: var(--cc_size_spacing_s);
`;

const zeroPad = (num: number) => String(num).padStart(2, '0');

type TranscriptItemProps = {
  text: string;
  seconds: number;
};

const TranscriptItem = ({ text, seconds }: TranscriptItemProps) => {
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });
  const formattedTimestamp = `${zeroPad(duration.minutes)}:${zeroPad(
    duration.seconds,
  )}`;

  return (
    <ContainerDiv>
      <Text as="span" size="xs" color="nonessential">
        ({formattedTimestamp})
      </Text>

      <Text as="span" size="s">
        {text}
      </Text>
    </ContainerDiv>
  );
};

export default TranscriptItem;
